import { query, combined, queryPickupBillCombinedInfo, cancelCombined,modifyPicker } from '@/services/forward/out/PickupCombined';
import { formatMessage } from 'umi/locale';

export default {
  namespace: 'pickupCombined',
  subscriptions: {
    /**
     * 监听浏览器地址
     * @param dispatch 触发器，用于触发 effects 中的 query 方法
     * @param history 浏览器历史记录，主要用到它的 location 属性以获取地址栏地址
     */
    setup({ dispatch, history }) {
      history.listen((location) => {
        if (location.payload && location.pathname == "/out/pickupCombined") {
          dispatch({
            type: 'showPage',
            payload: location.payload,
          })
        }
      });
    },
  },
  state: {
    data: {
      list: [],
      pagination: {},
    },
    showPage: 'query',
  },
  effects: {
    *queryWithSameStoreMultipleArea({ payload, callback }, { call, put }) {
      const response = yield call(query, payload);
      if (callback) callback(response);
    },
    *combined({ payload, callback }, { call, put }) {
      const response = yield call(combined, payload);
      if (callback) callback(response);
    },
    *queryPickupBillCombinedInfo({ payload, callback }, { call, put }) {
      const response = yield call(queryPickupBillCombinedInfo, payload);
      if (callback) callback(response);
    },
    *cancelCombined({ payload, callback }, { call, put }) {
      const response = yield call(cancelCombined, payload);
      if (callback) callback(response);
    },
    *modifyPicker({ payload, callback }, { call, put }) {
      const response = yield call(modifyPicker, payload);
      if (callback) callback(response);
    },
    

  }
}
